'use strict'
import { normalizeRoutingRow } from '../../PropertyDetail/propertyDetailHelpers'

// Guarded writeback for the drawer's selected property.
//
// `saveSelectedProperty` is async: its PATCH / billing-group writes resolve
// AFTER the user may have already clicked a different stop. Writing the saved
// site's server payload into whatever is selected NOW stomps the new site with
// the old site's data (e.g. stale prescribed hours). This mirrors the id-guard
// already used by openPropertyDetails' live-hydration: only merge if the still-
// selected property is the one we saved, otherwise leave the selection alone.
export const mergeIntoSelectedIfSameProperty = (prev, savedPropertyId, patch) => {
  if (!prev) return prev
  const prevId = Number(prev.aspirePropertyId || prev.propertyId)
  if (!Number.isFinite(prevId) || prevId !== Number(savedPropertyId)) return prev
  return normalizeRoutingRow({ ...prev, ...patch })
}
